import SantiFoto1 from "../img/Cabañas/Santi/Foto1.jpeg";
import SantiFoto2 from "../img/Cabañas/Santi/Foto2.jpeg";
import SantiFoto3 from "../img/Cabañas/Santi/Foto3.jpeg";
import SantiFoto4 from "../img/Cabañas/Santi/Foto4.jpeg";
import SantiFoto5 from "../img/Cabañas/Santi/Foto5.jpeg";

import FacuFoto1 from "../img/Cabañas/Facu/Foto1.jpeg";
import FacuFoto2 from "../img/Cabañas/Facu/Foto2.jpeg";
import FacuFoto3 from "../img/Cabañas/Facu/Foto3.jpeg";
import FacuFoto4 from "../img/Cabañas/Facu/Foto4.jpeg";
import FacuFoto5 from "../img/Cabañas/Facu/Foto5.jpeg";

import GonzaFoto1 from "../img/Cabañas/Gonza/Foto1.jpeg";
import GonzaFoto2 from "../img/Cabañas/Gonza/Foto2.jpeg";
import GonzaFoto3 from "../img/Cabañas/Gonza/Foto3.jpeg";
import GonzaFoto4 from "../img/Cabañas/Gonza/Foto4.jpeg";
import GonzaFoto5 from "../img/Cabañas/Gonza/Foto5.jpeg";

import AlmiFoto1 from "../img/Cabañas/Almi/Foto1.jpeg";
import AlmiFoto2 from "../img/Cabañas/Almi/Foto2.jpeg";
import AlmiFoto3 from "../img/Cabañas/Almi/Foto3.jpeg";
import AlmiFoto4 from "../img/Cabañas/Almi/Foto4.jpeg";

export const santiImgs = [SantiFoto1, SantiFoto2, SantiFoto3, SantiFoto4, SantiFoto5];
export const facuImgs = [FacuFoto1, FacuFoto2, FacuFoto3, FacuFoto4, FacuFoto5];
export const gonzaImgs = [GonzaFoto1, GonzaFoto2, GonzaFoto3, GonzaFoto4, GonzaFoto5];
export const almiImgs = [AlmiFoto1, AlmiFoto2, AlmiFoto3, AlmiFoto4];
